// extracted by mini-css-extract-plugin
module.exports = {"ClickButton":"PopForm_ClickButton__NTjUa","Header":"PopForm_Header__siCIX"};